import PropTypes from 'prop-types';

// Crossing channel ribbons form an X: connected commerce moving in both directions.
export function BrandMark({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false" style={{ flexShrink: 0 }}>
      <rect width="48" height="48" rx="14" fill="#005ddc" />
      <path d="M11 12h8l18 24h-8L11 12Z" fill="#fff" />
      <path d="M29 12h8L19 36h-8l18-24Z" fill="#70e3c0" />
      <path d="m21 25 4-5 5 7-4 5-5-7Z" fill="#fff" />
      <circle cx="11" cy="12" r="2" fill="#92c5ff" />
      <circle cx="37" cy="36" r="2" fill="#92c5ff" />
    </svg>
  );
}
BrandMark.propTypes = { size: PropTypes.number };

export default function Brand({ inverse = false, compact = false }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        gap: 10,
        alignItems: 'center',
        color: inverse ? '#fff' : '#15243b',
        textAlign: 'left',
        whiteSpace: 'nowrap'
      }}
    >
      <BrandMark size={compact ? 34 : 40} />
      <span style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <span
          style={{
            fontFamily: 'Public Sans, sans-serif',
            fontSize: compact ? 17 : 20,
            lineHeight: 1.1,
            fontWeight: 700,
            letterSpacing: '-.7px'
          }}
        >
          Xchan<span style={{ color: inverse ? '#92c5ff' : '#005ddc' }}>Ecom</span>
        </span>
        <span style={{ fontSize: 8, lineHeight: 1.1, fontWeight: 600, letterSpacing: '1.8px', color: inverse ? '#9bb8dc' : '#64748b' }}>
          DROPSHIPPING. CONNECTED.
        </span>
      </span>
    </span>
  );
}
Brand.propTypes = { inverse: PropTypes.bool, compact: PropTypes.bool };
